import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import momentDurationFormat from "moment-duration-format";
import "moment/locale/de";

momentDurationFormat(moment);

// Long dates use language-neutral patterns ("DD MMMM YYYY"); German writes the day before a month
// name as an ordinal ("21. Oktober 2026"), so the German locale adds that dot to every format.
const activeLocale = moment.locale();
const germanMonths = [
  ...moment.localeData("de").months(),
  ...moment.localeData("de").monthsShort(),
]
  .map((month) => month.replace(".", "\\."))
  .join("|");
const germanDayBeforeMonth = new RegExp(
  `(^|[^\\d.])(\\d{1,2}) (?=(${germanMonths})(?![\\p{L}]))`,
  "gu",
);
moment.updateLocale("de", {
  postformat: (text) => text.replace(germanDayBeforeMonth, "$1$2. "),
});
moment.locale(activeLocale);

Vue.use(VueMoment, {
  moment,
});

export default moment;
